var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFailPageIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 46,
  viewBox: "0 0 52 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 35L18 23L19 6L20.5 3L43.5 5L49 24L45.5 29L33 32.5V39L23.5 42L19.5 35Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.432 9.52561C48.253 4.04469 43.4173 0.123868 37.811 0.103149H11.878C5.32056 0.111478 0.00710938 5.42594 0 11.9833V22.7815C0.00710938 29.3386 5.32096 34.6524 11.878 34.6596H16.3723L19.6399 41.0586C21.144 43.99 24.1806 45.8147 27.475 45.7667C32.1875 45.7729 36.0127 41.9577 36.0189 37.2452C36.0195 36.7608 35.979 36.2774 35.8976 35.7999L35.7032 34.6597H40.1045C46.6645 34.6597 51.9825 29.3418 51.9825 22.7818C51.9825 21.9558 51.8964 21.1321 51.7255 20.324L49.432 9.52561ZM6.47887 22.7815V11.9833C6.47887 9.00145 8.89616 6.58426 11.8779 6.58426H15.1174V28.1806H11.8779C8.89616 28.1806 6.47887 25.7634 6.47887 22.7815ZM44.2876 26.183C43.2642 27.4496 41.722 28.1841 40.0936 28.1806H28.0169L29.5006 36.8883C29.6069 37.485 29.4396 38.0978 29.0448 38.5577C28.6249 39.045 28.0053 39.3138 27.3625 39.2876C26.5448 39.2962 25.7924 38.8422 25.4188 38.115L21.5962 30.6491V6.58426H37.8108C40.3592 6.59177 42.5576 8.37481 43.0911 10.8668L45.376 21.6651C45.7164 23.2581 45.3161 24.9195 44.2876 26.183Z",
  fill: "#5F1341"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFailPageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fail-page-icon.051171a77f28f96f847b9af8bebf7100.svg";